<template>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Login form</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field v-model="email" prepend-icon="person" name="login" label="Login" type="text"></v-text-field>
                  <v-text-field v-model="password" id="password" prepend-icon="lock" name="password" label="Password" type="password"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="authenticate" color="primary">Login</v-btn>
              </v-card-actions>
            </v-card>
            <v-card class="mx-auto"  max-width="344">
              <v-card-title class="error-message" v-if="error">
                {{ errorMsg }}
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

</template>
<script>

const fb = require('../../firebaseConfig.js')
import {mapState, mapActions} from 'vuex'
export default {
    data(){
        return{
            isLogin:true,
            email:'',
            password:'',
            errorMsg:'',
            error:false
        }
    },
    components:{
      ...mapState(['currentUser','authUser'])
    },
    methods:{
      ...mapActions(['setAuthUser','fetchCurrentUser']),
        authenticate(){

            this.error = false;
            let self = this;
            fb.auth.signInWithEmailAndPassword(this.email,this.password)
            .then((data)=>{

                
                this.$store.state.authUser = data.user;
                
                //console.log("this.authUser",this.$store.state.authUser)
                this.$store.state.issuesBuffer.issues = []
                
                this.fetchCurrentUser()

                setTimeout(()=>{
                  self.$router.push('/issues')
                },1000)
                

                  /*
                  if (!self.$store.state.currentUser || 
                    self.$store.state.currentUser == undefined){
                    self.$store.fetchCurrentUser()
                  }
                  if (self.$store.state.currentUser.userType == 'client'){
                      self.$router.push('/client')
                  }if (self.$store.state.currentUser.userType == 'assignee'){
                      self.$router.push('/assignee')
                  }else if (self.$store.state.currentUser.userType == 'admin'){
                    self.$router.push('/issues')
                  }
                  */

                

            })
            .catch(err=>{
                console.log("error",err.message)
                //this.performingRequest = false
                this.error = true;
                this.errorMsg = err.message
            })            
        }
    },
    created(){
      console.log("Login created")
      this.email = ''
      this.password = ''

      this.$store.state.assignees = []
      this.$store.state.departments = []
      this.$store.state.sections = []
      this.$store.state.issueMaster = []
      this.$store.state.issueTypes = []
      this.$store.state.issueSubtypes = []
      this.$store.state.locations = []
      this.$store.state.sections = []
      this.$store.state.assignees = []
      this.$store.state.solutionTypes = []
      this.$store.state.solutions = []
      this.$store.state.solutionMethods = []
      this.$store.state.diagnostics = []
      this.$store.state.diagnosticTypes = []

      this.$store.state.issueStatuses = []
      this.$store.state.problemSources = []
      this.$store.state.accountablePersons = []


    },
    mounted(){
      console.log("Login mounted")
      this.email = ''
      this.password = ''

    }
}
</script>
<style scoped>
.error-message{
  color: red;
}
</style>
